export default __webpack_public_path__ + "static/media/DSC02232.1378eab2.jpg";